import { apiRequest } from "../../index";

export const addOrUpdateCartItem = async (data) => {
  return apiRequest(`/api/user/restaurants/cart/add-or-update`, "POST", data);
};

export const removeCartItem = async (data) => {
  return apiRequest(`/api/user/restaurants/cart/remove`, "POST", data);
};

export const updateCartItemQuantity = async (data) => {
  return apiRequest(`/api/user/restaurants/cart/update-quantity`, "POST", data);
};

export const getCart = async () => {
  return apiRequest(`/api/user/restaurants/cart/get`, "GET");
};

export const getCartPrice = async (data) => {
  return apiRequest(`/api/user/restaurants/cart/items-price`, "POST", data);
};

export const clearCart = async (data) => {
  return apiRequest(`/api/user/restaurants/cart/clear`, "POST", data);
};